export const CONTROLLER_BUTTON_THEME = [
  'bg-lightMode-gray',
  'dark:bg-darkMode-gray',
  'hover:bg-lightMode-gray-hover',
  'dark:focus:bg-darkMode-gray',
  'focus:bg-lightMode-gray'
];
